import { Tooltip } from '@rematter/ui-web';

type ContainerItem = {
  containerType: { name: string };
  quantity: number;
};

type ContainersBadgeListProps = {
  id?: string;
  containers: ContainerItem[];
};

const badgeClass = 'rounded bg-neutral/10 px-2 py-1 text-xs text-neutral/70';

//
// ⚛️ ⚛️ ⚛️ CONTAINERS BADGE LIST ⚛️ ⚛️ ⚛️
//
export const ContainersBadgeList = ({
  id,
  containers,
}: ContainersBadgeListProps) => {
  if (containers.length === 0) {
    return <>-</>;
  }

  const formatted = containers.map(
    (c) => `${c.quantity} x ${c.containerType.name}`,
  );
  const [first, ...rest] = formatted;

  return (
    <div className="@ContainersBadgeList flex items-center gap-1 text-left">
      <div className={badgeClass}>{first}</div>
      {rest.length > 0 && (
        <Tooltip
          tip={
            <div className="flex flex-col gap-1">
              {rest.map((label, index) => (
                <span key={`${id}-${index}`}>{label}</span>
              ))}
            </div>
          }
        >
          <div className={badgeClass}>+{rest.length}</div>
        </Tooltip>
      )}
    </div>
  );
};
